module.exports = __webpack_public_path__ + "img/itip.8f097b7f.jpeg";